export enum StatusColors {
    Completed = 'green',
    Pending = 'yellow',
    InProgress = 'yellow',
    Scheduled = 'blue',
    Overdue = 'red',
    Missed = 'orange',
}
